export const ParcoursModele = [
  {key: 'Parcours', value: 1},
  {key: 'Parcours Composé', value: 2},
  {key: 'Session', value: 0},
];
export const ParcoursType = [
  {key: 'Parcours', value: 1},
  {key: 'Parcours Composé', value: 2},
];

export enum TypeParcours{
  SESSION = 0,
  PARCOURS = 1,
  PARCOURS_COMPOSE = 2,
}
